module.exports = __webpack_public_path__ + "six_flags.5f044c91deb05389fdcef2e917f9ba2a.png";